import React from 'react';

export class DocumentSerialNumberManagementField extends React.Component{

	constructor(props) {
		super(props);
		this.state = {
			entryIndex: props.entryIndex,
			serialNumberShadow: props.serialNumber,
			displaySerialNumber: props.serialNumber
		}
	}


	render() {
		return (<>{this.state.displaySerialNumber}</>);
	}
}